import { useState, useEffect, forwardRef } from "react";
import { Button, Dialog, DialogContent, DialogActions, DialogTitle, TextField, Grid, IconButton, Checkbox, FormControlLabel, RadioGroup, Radio, Select, MenuItem, FormLabel, FormGroup, FormControl, Tabs, Tab, Box, InputLabel, Typography, Alert, AlertTitle, List, ListItem, ListItemText } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { gettingAllPaycodes, gettingAllWorkRules } from 'utils/CreditHolidayRule'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';


const TextMaskCustom = forwardRef((props, ref) => {
    return (
        <IMaskInput
            {...props}
            mask="00:#0"
            definitions={{
                '0': /[0-9]/,
                '#': /[0-5]/,
            }}
            placeholder={props.name === 'long_interval' ? '99:00' : '24:00'}
            inputRef={ref}
            onAccept={(value) => props.onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

const AdmisibilityTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ width: '100%' }}>
                    <>{children}</>
                </Box>
            )}
        </div>
    );
}

AdmisibilityTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const CreditTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ width: '100%', mt: 0 }}>
                    <>{children}</>
                </Box>
            )}
        </div>
    );
}

CreditTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const AverageTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ width: '100%', mt: 0 }}>
                    <>{children}</>
                </Box>
            )}
        </div>
    );
}

AverageTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const InfoCreditHolidayRule = ({ open, setOpen, selectedRow }) => {
    const { t } = useTranslation()
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [type_credit, setTypeCredit] = useState('')
    const [must_work_shift_before_holiday, setMustWorkShiftBeforeHoliday] = useState(false)
    const [must_work_shift_after_holiday, setMustWorkShiftAfterHoliday] = useState(false)
    const [must_work_shift_before_or_after_holiday, setMustWorkShiftBeforeOrAfterHoliday] = useState(false)
    const [must_work_shift_in_holiday, setMustWorkShiftInHoliday] = useState(false)
    const [shift_equivalent_to, setShiftEquivalentTo] = useState("")
    const [if_planned_more_one_shift_in_day, setIfPlannedMoreOneShiftInDay] = useState('')
    const [hours_belong, setHoursBelong] = useState('')
    const [zone_holiday_defined_by, setZoneHolidayDefinedBy] = useState('')
    const [pay_credits_like, setPayCreditsLike] = useState('')
    const [work_rule, setWorkRule] = useState([])
    const [selected_work_rule, setSelectedWorkRule] = useState("")
    const [quantity_of_hours, setQuantityOfHours] = useState('')
    const [time_deducted_from_holiday_credit, setTimeDeductedFromHolidayCredit] = useState('')
    const [consider_on_extratime_limit, setConsiderOnExtratimeLimit] = useState('')
    const [consider_on_extratime_consecutive_days, setConsiderOnExtratimeConsecutiveDays] = useState('')
    const [paycodes_extra_limit, setPaycodesExtraLimit] = useState([])
    const [selected_paycodes_extra_limit, setSelectedPaycodesExtraLimit] = useState("")
    const [paycodes_extra_consecutive_days, setPaycodesExtraConsecutiveDays] = useState([])
    const [selected_paycodes_extra_consecutive_days, setSelectedPaycodesExtraConsecutiveDays] = useState("")
    const [loading, setLoading] = useState(true)
    const [value, setValue] = useState(0);
    const [transferredItems, setTransferredItems] = useState([]);

    useEffect(() => {
        const requests = async () => {
            try {
                const [paycodesResult, workRulesResult] = await Promise.allSettled([
                    gettingAllPaycodes(setLoading),
                    gettingAllWorkRules(setLoading)
                ]);

                if (paycodesResult.status === "fulfilled") {
                    const paycodes = paycodesResult.value;

                    setPaycodesExtraLimit(paycodes);
                    setPaycodesExtraConsecutiveDays(paycodes);
                } else {
                    console.error('Error in paycodes request:', paycodesResult.reason);
                }

                if (workRulesResult.status === "fulfilled") {
                    const workRules = workRulesResult.value;
                    setWorkRule(workRules);
                } else {
                    console.error('Error in work rules request:', workRulesResult.reason);
                }

                if (selectedRow) {
                    setName(selectedRow[0].name);
                    setDescription(selectedRow[0].description);
                    setMustWorkShiftBeforeHoliday(selectedRow[0].must_work_shift_before_holiday);
                    setMustWorkShiftAfterHoliday(selectedRow[0].must_work_shift_after_holiday);
                    setMustWorkShiftBeforeOrAfterHoliday(selectedRow[0].must_work_shift_before_or_after_holiday);
                    setMustWorkShiftInHoliday(selectedRow[0].must_work_shift_in_holiday);
                    setShiftEquivalentTo(selectedRow[0].shift_equivalent_to);
                    setTypeCredit(selectedRow[0].credit_type);
                    setIfPlannedMoreOneShiftInDay(selectedRow[0].if_planned_more_one_shift_in_day);
                    setQuantityOfHours(selectedRow[0].amount_hours);
                    setHoursBelong(selectedRow[0].hours_belong);
                    setZoneHolidayDefinedBy(selectedRow[0].zone_holiday_defined_by);
                    setPayCreditsLike(selectedRow[0].pay_credits_like);
                    setSelectedWorkRule(selectedRow[0].work_rule_id);
                    setConsiderOnExtratimeLimit(selectedRow[0].consider_on_extratime_limit ? selectedRow[0].consider_on_extratime_limit : '');
                    setConsiderOnExtratimeConsecutiveDays(selectedRow[0].consider_on_extratime_consecutive_days ? selectedRow[0].consider_on_extratime_consecutive_days : '');
                    setTransferredItems(selectedRow[0].pay_credits_like === "Como si trabajara" ? [] : selectedRow[0].paycodes);
                    setSelectedPaycodesExtraLimit(selectedRow[0].paycode_extratime_limit_id ? selectedRow[0].paycode_extratime_limit_id : "");
                    setSelectedPaycodesExtraConsecutiveDays(selectedRow[0].paycode_extratime_consecutive_days_id ? selectedRow[0].paycode_extratime_consecutive_days_id : "");
                }

                setLoading(false);
            } catch (error) {
                console.error('Error during requests:', error.message);
                setLoading(false);
            }
        };

        if (open && loading) requests();

    }, [open, loading, transferredItems, selectedRow]);


    const cleanForm = () => {
        setName('')
        setDescription('')
        setMustWorkShiftBeforeHoliday(false)
        setMustWorkShiftAfterHoliday(false)
        setMustWorkShiftBeforeOrAfterHoliday(false)
        setMustWorkShiftInHoliday(false)
        setShiftEquivalentTo("")
        setIfPlannedMoreOneShiftInDay('')
        setHoursBelong('')
        setZoneHolidayDefinedBy('')
        setPayCreditsLike('')
        setSelectedWorkRule('')
        setQuantityOfHours('')
        setTimeDeductedFromHolidayCredit('')
        setConsiderOnExtratimeLimit('')
        setConsiderOnExtratimeConsecutiveDays('')
        setSelectedPaycodesExtraLimit('')
        setSelectedPaycodesExtraConsecutiveDays('')
        setValue(0)
        setTransferredItems([])
        setOpen(false)
        setLoading(true)
    }


    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>{t('settings.credit_holiday_rule.dialog.titles.info')}</DialogTitle>

            <IconButton
                aria-label="close"
                onClick={() => cleanForm()}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent dividers>
                {JSON.parse(localStorage.getItem("permissions")).filter(permission => ['timekeeper.CreditHolidayRulesById', 'timekeeper.WorkRule', 'timekeeper.GetPaycodes'].includes(permission)).length !== 3 &&
                    <Alert severity="warning">
                        <AlertTitle>{t('general.alerts.missing_permission.title')}</AlertTitle>

                        <List dense>
                            {JSON.parse(localStorage.getItem("permissions")).find(permission => permission === 'timekeeper.CreditHolidayRulesById') === undefined &&
                                <ListItem>
                                    <ListItemText
                                        primary={'timekeeper.CreditHolidayRulesById'}
                                    />
                                </ListItem>
                            }

                            {JSON.parse(localStorage.getItem("permissions")).find(permission => permission === 'timekeeper.WorkRule') === undefined &&
                                <ListItem>
                                    <ListItemText
                                        primary={'timekeeper.WorkRule'}
                                    />
                                </ListItem>
                            }

                            {JSON.parse(localStorage.getItem("permissions")).find(permission => permission === 'timekeeper.GetPaycodes') === undefined &&
                                <ListItem>
                                    <ListItemText
                                        primary={'timekeeper.GetPaycodes'}
                                    />
                                </ListItem>
                            }
                        </List>
                    </Alert>
                }
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: 1.5 }}>
                        <TextField
                            id='name'
                            fullWidth
                            label={t('settings.credit_holiday_rule.dialog.inputs.name')}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            disabled={true}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 1.5 }}>
                            <Tabs value={value} onChange={(event, newValue) => setValue(newValue)} aria-label="basic tabs example">
                                <Tab label={t('settings.credit_holiday_rule.dialog.inputs.admissibility')} {...a11yProps(0)} />
                                <Tab label={t('settings.credit_holiday_rule.dialog.inputs.credits')} {...a11yProps(1)} />
                                <Tab label={t('settings.credit_holiday_rule.dialog.inputs.average')} {...a11yProps(2)} disabled />
                            </Tabs>
                        </Box>
                    </Grid>

                    <AdmisibilityTabPanel value={value} index={0}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.must_work_planned_shift')}</FormLabel>
                                <FormControl sx={{ mt: 1.5 }} disabled={true}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Checkbox disabled={true} checked={must_work_shift_before_holiday} onChange={(e) => setMustWorkShiftBeforeHoliday(e.target.checked)} />}
                                            label={t('settings.credit_holiday_rule.dialog.inputs.must_work_shift_before_holiday')}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox disabled={true} checked={must_work_shift_after_holiday} onChange={(e) => setMustWorkShiftAfterHoliday(e.target.checked)} />}
                                            label={t('settings.credit_holiday_rule.dialog.inputs.must_work_shift_after_holiday')}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox disabled={true} value={must_work_shift_before_or_after_holiday} checked={must_work_shift_before_or_after_holiday} />}
                                            label={t('settings.credit_holiday_rule.dialog.inputs.must_work_shift_before_or_after_holiday')}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox disabled={true} value={must_work_shift_in_holiday} checked={must_work_shift_in_holiday} />}
                                            label={t('settings.credit_holiday_rule.dialog.inputs.must_work_shift_in_holiday')}
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.shift_equivalent_to')}</FormLabel>
                                <RadioGroup row aria-label="shift_equivalent_to" disabled={true} name="shift_equivalent_to" value={shift_equivalent_to}>
                                    <FormControlLabel value="Turno realmente planificado" disabled={true} control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.shift_real_planned')} />
                                    <FormControlLabel value="Todo turno en el dia del turno planificad" disabled={true} control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.all_shift_on_day_planned')} />
                                </RadioGroup>
                            </Grid>
                        </Grid>

                    </AdmisibilityTabPanel>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <CreditTabPanel value={value} index={1}>
                            <FormControl fullWidth>
                                <InputLabel id="credit_type-select-label">{t('settings.credit_holiday_rule.dialog.inputs.credit_type')}</InputLabel>
                                <Select
                                    value={type_credit ? type_credit : ''}
                                    fullWidth
                                    autoWidth={true}
                                    label={t('settings.credit_holiday_rule.dialog.inputs.credit_type')}
                                    disabled={true}
                                    sx={{ mt: 0 }}
                                >
                                    <MenuItem disabled value={'fixed_quantity_of_hours'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.fixed_quantity_of_hours")}</MenuItem>
                                    <MenuItem disabled value={'fixed_salaries'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.fixed_salaries")}</MenuItem>
                                    <MenuItem disabled value={'hours_from_schedule'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.hours_from_schedule")}</MenuItem>
                                    <MenuItem disabled value={'percentage_of_salaries'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.percentage_of_salaries")}</MenuItem>
                                    <MenuItem disabled value={'average_shift_duration'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.average_shift_duration")}</MenuItem>
                                    <MenuItem disabled value={'average_salaries'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.average_salaries")}</MenuItem>
                                    <MenuItem disabled value={'average_shift_duration_with_free_time_rule'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.average_shift_duration_with_free_time_rule")}</MenuItem>
                                    <MenuItem disabled value={'average_salaries_with_free_time_rule'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.average_salaries_with_free_time_rule")}</MenuItem>
                                    <MenuItem disabled value={'percentage_of_salaries_utilizing_free_time_rule'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.percentage_of_salaries_utilizing_free_time_rule")}</MenuItem>
                                </Select>
                            </FormControl>
                            <Grid container spacing={2}>
                                {/* FORMULARIOS POR TIPO DE CREDITOS */}
                                {/* FORMULARIO TIPO HORAS DESDE HORARIO */}
                                {
                                    type_credit === 'hours_from_schedule' && (
                                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                            <Grid container spacing={2} sx={{ mt: 1.5 }}>
                                                <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>{t('settings.credit_holiday_rule.dialog.inputs.if_planned_more_one_shift_in_day')}</InputLabel>
                                                        <Select
                                                            label={t('settings.credit_holiday_rule.dialog.inputs.if_planned_more_one_shift_in_day')}
                                                            value={if_planned_more_one_shift_in_day ? if_planned_more_one_shift_in_day : ""}
                                                            fullWidth
                                                            autoWidth={true}
                                                            disabled={true}
                                                        >
                                                            <MenuItem value={'use_first_shift'}>{t("settings.credit_holiday_rule.dialog.inputs.use_first_shift")}</MenuItem>
                                                            <MenuItem value={'use_sum_of_all_shifts'}>{t("settings.credit_holiday_rule.dialog.inputs.use_sum_of_all_shifts")}</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} sx={{ mt: 1.5 }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>{t('settings.credit_holiday_rule.dialog.inputs.hours_belong')}</InputLabel>
                                                        <Select
                                                            label={t('settings.credit_holiday_rule.dialog.inputs.hours_belong')}
                                                            value={hours_belong}
                                                            fullWidth
                                                            autoWidth={true}
                                                            disabled={true}
                                                        >
                                                            <MenuItem value={'value_fixed_rule'}>{t("settings.credit_holiday_rule.dialog.inputs.fixe_rule_value")}</MenuItem>

                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: 1.5 }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>{t('settings.credit_holiday_rule.dialog.inputs.zone_holiday_defined_by')}</InputLabel>
                                                        <Select
                                                            label={t('settings.credit_holiday_rule.dialog.inputs.zone_holiday_defined_by')}
                                                            value={zone_holiday_defined_by}
                                                            fullWidth
                                                            autoWidth={true}
                                                            disabled={true}
                                                        >
                                                            <MenuItem value={'hours_on_holiday_table'}>{t("settings.credit_holiday_rule.dialog.inputs.hours_on_holiday_table")}</MenuItem>
                                                            <MenuItem value={'division_hours_into_days'}>{t("settings.credit_holiday_rule.dialog.inputs.division_hours_into_days")}</MenuItem>

                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                    <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.pay_credits_like')}</FormLabel>
                                                    <RadioGroup disabled={true} aria-label="pay_credits_like" name="pay_credits_like" value={pay_credits_like}>
                                                        <FormControlLabel disabled={true} value="Como si trabajara" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.how_if_work')} />
                                                        <FormControlLabel disabled={true} value="En codigos de pagos" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.in_pay_codes')} />
                                                    </RadioGroup>
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel>{t('settings.credit_holiday_rule.dialog.inputs.work_rule')}</InputLabel>

                                                        <Select
                                                            label={t('settings.credit_holiday_rule.dialog.inputs.work_rule')}
                                                            value={selected_work_rule ? selected_work_rule : ""}
                                                            fullWidth
                                                            disabled={true}
                                                            renderValue={(selected) => {
                                                                const selectedWorkRule = work_rule.find(rule => rule.work_rule_id === selected);
                                                                return selectedWorkRule ? selectedWorkRule.name : '';
                                                            }}
                                                            autoWidth={true}
                                                        >
                                                            {
                                                                work_rule.map((work_rule) => (
                                                                    <MenuItem key={work_rule.work_rule_id} value={work_rule.work_rule_id}>{work_rule.name}</MenuItem>
                                                                ))
                                                            }

                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                {
                                                    pay_credits_like === 'En codigos de pagos' && (
                                                        <>
                                                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                                                <Grid sx={{ mt: 1.5 }}>
                                                                    <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.credits_included_in_payment_codes')}</FormLabel>
                                                                    <Grid disabled size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ p: 1.5, border: '1px solid grey', borderRadius: '5px' }}>
                                                                        {
                                                                            transferredItems.length > 0 ? transferredItems.map((paycode, index) => (
                                                                                <Typography sx={{ p: 1 }} key={`name_${index}`} color={'grey'} variant="body1">{paycode.name}</Typography>
                                                                            )) : <FormLabel sx={{ p: 1 }} component="legend">{'No tiene paycodes asignados'}</FormLabel>
                                                                        }
                                                                    </Grid>

                                                                </Grid>
                                                                <Grid sx={{ mt: 1.5 }}>
                                                                    <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.consider_on_extratime_limit')}</FormLabel>
                                                                </Grid>
                                                                <Grid container direction='row' textAlign='end' columnSpacing={{ xs: 2, md: 2 }}>
                                                                    <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} sx={{ mt: 1.5 }}>
                                                                        <RadioGroup disabled={true} aria-label="consider_on_extratime_limit" name="consider_on_extratime_limit" value={consider_on_extratime_limit} onChange={(e) => setConsiderOnExtratimeLimit(e.target.value)}>
                                                                            <FormControlLabel disabled={true} value="paycode" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.paycode')} />
                                                                            <FormControlLabel disabled={true} value="always" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.always')} />
                                                                            <FormControlLabel disabled={true} value="never" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.never')} />
                                                                        </RadioGroup>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign='initial' sx={{ mt: 1.5 }}>
                                                                        <FormControl fullWidth size="small">
                                                                            <InputLabel id='consider_on_extratime_limit'>{t('settings.credit_holiday_rule.dialog.inputs.paycode')}</InputLabel>
                                                                            <Select
                                                                                disabled={true}
                                                                                labelId='select_consider_on_extratime_limit'
                                                                                id="consider_on_extratime_limit"
                                                                                label={t('settings.credit_holiday_rule.dialog.inputs.paycode')}
                                                                                value={selected_paycodes_extra_limit ? selected_paycodes_extra_limit : ""}
                                                                                fullWidth
                                                                                renderValue={(selected) => {
                                                                                    const selectedPaycode = transferredItems.find(paycode => paycode.paycode_id === selected);
                                                                                    return selectedPaycode ? selectedPaycode.name : '';
                                                                                }}
                                                                                autoWidth={true}
                                                                            >
                                                                                {
                                                                                    transferredItems.map((paycode) => (
                                                                                        <MenuItem key={`consider_on_extratime_limit_paycode${paycode.paycode_id}`} value={paycode.paycode_id}>{paycode.name}</MenuItem>
                                                                                    ))
                                                                                }
                                                                            </Select>
                                                                        </FormControl>

                                                                    </Grid>
                                                                </Grid>
                                                                <Grid sx={{ mt: 1.5 }}>
                                                                    <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.consider_on_extratime_consecutive_days')}</FormLabel>
                                                                </Grid>
                                                                <Grid container direction='row' textAlign='end' columnSpacing={{ xs: 2, md: 2 }}>
                                                                    <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} sx={{ mt: 1.5 }}>
                                                                        <RadioGroup disabled={true} aria-label="consider_on_extratime_consecutive_days" name="consider_on_extratime_consecutive_days" value={consider_on_extratime_consecutive_days}>
                                                                            <FormControlLabel disabled={true} value="paycode" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.paycode')} />
                                                                            <FormControlLabel disabled={true} value="always" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.always')} />
                                                                            <FormControlLabel disabled={true} value="never" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.never')} />
                                                                        </RadioGroup>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign='initial' sx={{ mt: 1.5 }}>
                                                                        <FormControl fullWidth size="small">
                                                                            <InputLabel id="consider_on_extratime_consecutive_days">{t('settings.credit_holiday_rule.dialog.inputs.paycode')}</InputLabel>
                                                                            <Select
                                                                                labelId="select_consider_on_extratime_consecutive_days"
                                                                                id="consider_on_extratime_consecutive_days"
                                                                                value={selected_paycodes_extra_consecutive_days ? selected_paycodes_extra_consecutive_days : ""}
                                                                                label={t('settings.credit_holiday_rule.dialog.inputs.paycode')}
                                                                                renderValue={(selected) => {
                                                                                    const selectedPaycode = transferredItems.find(paycode => paycode.paycode_id === selected);
                                                                                    return selectedPaycode ? selectedPaycode.name : '';
                                                                                }}
                                                                                fullWidth
                                                                                autoWidth={true}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    transferredItems.map((paycode) => (
                                                                                        <MenuItem key={`consider_on_extratime_consecutive_days_paycode${paycode.paycode_id}`} value={paycode.paycode_id}>{paycode.name}</MenuItem>
                                                                                    ))
                                                                                }

                                                                            </Select>
                                                                        </FormControl>

                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>

                                                        </>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    )}
                                <Grid />

                                {/* FIN FORMULARIO HORAS DESDE HORARIO */}
                                {/* FORMULARIO TIPO CANTIDAD FIJA DE HORAS */}
                                {
                                    type_credit === 'fixed_quantity_of_hours' && (
                                        <>
                                            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                <TextField
                                                    disabled
                                                    fullWidth
                                                    value={quantity_of_hours}
                                                    label={t('settings.credit_holiday_rule.dialog.inputs.quantity_of_hours')}
                                                    slotProps={{
                                                        input: {
                                                            inputComponent: TextMaskCustom,
                                                            inputProps: { name: 'quantity_of_hours' }
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                <FormControl fullWidth>
                                                    <InputLabel>{t('settings.credit_holiday_rule.dialog.inputs.time_deducted_from_holiday_credit')}</InputLabel>
                                                    <Select
                                                        label={t('settings.credit_holiday_rule.dialog.inputs.time_deducted_from_holiday_credit')}
                                                        value={time_deducted_from_holiday_credit}
                                                        fullWidth
                                                        autoWidth={true}
                                                        disabled={true}
                                                    >
                                                        <MenuItem value={'value_zone_rule'}>{t('settings.credit_holiday_rule.dialog.inputs.value_zone_rule')}</MenuItem>
                                                        <MenuItem value={'none'}>{t('settings.credit_holiday_rule.dialog.inputs.none')}</MenuItem>
                                                        <MenuItem value={'hours_worked'}>{t('settings.credit_holiday_rule.dialog.inputs.hours_worked')}s</MenuItem>
                                                        <MenuItem value={'full_credit'}>{t('settings.credit_holiday_rule.dialog.inputs.full_credit')}</MenuItem>

                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                                <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.credits_included_in_payment_codes')}</FormLabel>
                                                <Grid disabled size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ p: 1.5, border: '1px solid grey', borderRadius: '5px' }}>
                                                    {
                                                        transferredItems.length > 0 ? transferredItems.map((paycode, index) => (
                                                            <Typography sx={{ p: 1 }} key={`name_${index}`} color={'grey'} variant="body1">{paycode.name}</Typography>
                                                        )) : <FormLabel sx={{ p: 1 }} component="legend">{'No tiene paycodes asignados'}</FormLabel>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </>
                                    )
                                }

                            </Grid>
                            {/* FIN FORMULARIO HORAS DESDE HORARIO */}
                            {/* FORMULARIO TIPO CANTIDAD FIJA DE HORAS */}
                            {
                                type_credit === 'fixed_quantity_of_hours' && (
                                    <>
                                        <Grid sx={{ mt: 2.5 }}>
                                            <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.consider_on_extratime_limit')}</FormLabel>
                                        </Grid>
                                        <Grid container direction='row' textAlign='end' columnSpacing={{ xs: 2, md: 2 }}>
                                            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} sx={{ mt: 1.5 }}>
                                                <RadioGroup disabled={true} aria-label="consider_on_extratime_limit" name="consider_on_extratime_limit" value={consider_on_extratime_limit}>
                                                    <FormControlLabel disabled={true} value="paycode" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.paycode')} />
                                                    <FormControlLabel disabled={true} value="always" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.always')} />
                                                    <FormControlLabel disabled={true} value="never" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.never')} />
                                                </RadioGroup>
                                            </Grid>
                                            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign='initial' sx={{ mt: 1.5 }}>
                                                <FormControl fullWidth size="small">
                                                    <InputLabel id='label_consider_on_extratime_limit'>{t('settings.credit_holiday_rule.dialog.inputs.paycode')}</InputLabel>
                                                    <Select
                                                        labelId='select_consider_on_extratime_limit'
                                                        id="consider_on_extratime_limit"
                                                        label={t('settings.credit_holiday_rule.dialog.inputs.paycode')}
                                                        value={selected_paycodes_extra_limit}
                                                        fullWidth
                                                        renderValue={(selected) => {
                                                            const selectedPaycode = paycodes_extra_limit.find(paycode => paycode.paycode_id === selected);
                                                            return selectedPaycode ? selectedPaycode.name : '';
                                                        }}
                                                        autoWidth={true}
                                                        disabled={true}
                                                    >
                                                        {
                                                            paycodes_extra_limit.map((paycode) => (
                                                                <MenuItem key={`consider_on_extratime_limit_paycode${paycode.paycode_id}`} value={paycode.paycode_id}>{paycode.name}</MenuItem>
                                                            ))
                                                        }
                                                    </Select>
                                                </FormControl>

                                            </Grid>
                                        </Grid>
                                        <Grid sx={{ mt: 1.5 }}>
                                            <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.consider_on_extratime_consecutive_days')}</FormLabel>
                                        </Grid>
                                        <Grid container direction='row' textAlign='end' columnSpacing={{ xs: 2, md: 2 }}>
                                            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} sx={{ mt: 1.5 }}>
                                                <RadioGroup disabled={true} aria-label="consider_on_extratime_consecutive_days" name="consider_on_extratime_consecutive_days" value={consider_on_extratime_consecutive_days}>
                                                    <FormControlLabel disabled={true} value="paycode" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.paycode')} />
                                                    <FormControlLabel disabled={true} value="always" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.always')} />
                                                    <FormControlLabel disabled={true} value="never" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.never')} />
                                                </RadioGroup>
                                            </Grid>
                                            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign='initial' sx={{ mt: 1.5 }}>
                                                <FormControl fullWidth size="small">
                                                    <InputLabel id="paycode2">{t('settings.credit_holiday_rule.dialog.inputs.paycode')}</InputLabel>
                                                    <Select
                                                        labelId="paycode2"
                                                        id="consider_on_extratime_consecutive_days"
                                                        value={selected_paycodes_extra_consecutive_days}
                                                        label={t('settings.credit_holiday_rule.dialog.inputs.paycode')}
                                                        renderValue={(selected) => {
                                                            const selectedPaycode = paycodes_extra_limit.find(paycode => paycode.paycode_id === selected);
                                                            return selectedPaycode ? selectedPaycode.name : '';
                                                        }}
                                                        fullWidth
                                                        disabled={true}
                                                        autoWidth={true}

                                                    >
                                                        {
                                                            paycodes_extra_consecutive_days.map((paycode) => (
                                                                <MenuItem key={`consider_on_extratime_consecutive_days_paycode${paycode.paycode_id}`} value={paycode.paycode_id}>{paycode.name}</MenuItem>
                                                            ))
                                                        }

                                                    </Select>
                                                </FormControl>

                                            </Grid>
                                        </Grid>
                                    </>
                                )
                            }

                        </CreditTabPanel>
                    </Grid>
                    <AverageTabPanel value={value} index={2}>
                    </AverageTabPanel>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: 1.5 }}>
                        <TextField
                            id="filled-textarea"
                            fullWidth
                            label={t('settings.credit_holiday_rule.dialog.inputs.description')}
                            value={description}
                            multiline
                            slotProps={{
                                input: { maxLength: 255 }
                            }}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled={true}
                        />
                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)} variant="contained" color="error">{t('general.buttons.close')}</Button>
            </DialogActions>
        </Dialog>
    )
}

export { InfoCreditHolidayRule };